// extracted by mini-css-extract-plugin
module.exports = {"column":"_86294a","masonry":"_ac64a0"};